import { render, staticRenderFns } from "./custInbound.vue?vue&type=template&id=5ac821a2&scoped=true&"
import script from "./custInbound.vue?vue&type=script&lang=js&"
export * from "./custInbound.vue?vue&type=script&lang=js&"
import style0 from "./custInbound.vue?vue&type=style&index=0&id=5ac821a2&scoped=true&lang=scss&"
import style1 from "./custInbound.vue?vue&type=style&index=1&id=5ac821a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac821a2",
  null
  
)

export default component.exports